import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const fragment = window.location.hash || "";
    const params = new URLSearchParams(fragment.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }
    (async () => {
      try {
        const { data } = await api.post("/auth/session", null, {
          headers: { "X-Session-ID": sessionId },
        });
        if (data.token) localStorage.setItem("bh_token", data.token);
        window.history.replaceState({}, "", "/");
        await refresh();
        const pending = localStorage.getItem("bh_pending_transfer");
        if (pending) {
          localStorage.removeItem("bh_pending_transfer");
          navigate(`/accept-ownership?token=${encodeURIComponent(pending)}`, { replace: true });
        } else {
          navigate("/", { replace: true });
        }
      } catch (e) {
        console.error(e);
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center text-[#3a372b]">
      <div className="text-center">
        <div className="w-8 h-8 rounded-full border-2 border-[#3a372b] border-t-transparent animate-spin mx-auto mb-4" />
        <div>Inloggen…</div>
      </div>
    </div>
  );
}
